import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Star } from "lucide-react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

const defaultTestimonials = [
  { id: "1", name: "Ahmet Yılmaz", title: "Gayrimenkul Yatırımcısı", text: "BCT Yapı ile çalışmak büyük bir ayrıcalık." },
  { id: "2", name: "Fatma Demir", title: "Konut Sahibi", text: "Evimizin yapım sürecinde her aşamada bilgilendirildi." },
  { id: "3", name: "Mehmet Kaya", title: "İş İnsanı", text: "Ofis binamızın inşaatında gösterdikleri profesyonellik bizi çok memnun etti." },
  { id: "4", name: "Ayşe Çelik", title: "Mimar", text: "BCT Yapı'nın teknik yetkinliğini takdir ediyorum." },
];

export default function Testimonials() {
  const [items, setItems] = useState(defaultTestimonials);

  useEffect(() => {
    axios.get(`${API}/api/testimonials`).then((r) => {
      if (r.data.length > 0) setItems(r.data);
    }).catch(() => {});
  }, []);

  return (
    <section data-testid="testimonials-section" className="py-20 sm:py-28 bg-[#0C0C0C]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="text-center mb-14">
          <p className="overline justify-center mb-5">Müşteri Görüşleri</p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tighter text-white" style={{ fontFamily: "Outfit" }}>
            Müşterilerimiz <span className="text-[#FF5A00]">ne diyor?</span>
          </h2>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {items.map((t, i) => (
            <motion.div key={t.id} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.1, duration: 0.5 }}
              className="bg-[#1A1A1A] rounded-2xl p-6 border border-[#2a2a2a] hover:border-[#FF5A00]/30 transition-colors" data-testid={`testimonial-${t.id}`}>
              <div className="flex gap-1 mb-4">
                {[...Array(5)].map((_, j) => <Star key={j} size={14} className="fill-[#FF5A00] text-[#FF5A00]" />)}
              </div>
              <p className="text-gray-400 text-sm leading-relaxed mb-6">"{t.text}"</p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#FF5A00] to-[#FF8A3D] flex items-center justify-center text-white font-bold text-sm" style={{ fontFamily: "Outfit" }}>
                  {t.name?.charAt(0)}
                </div>
                <div>
                  <p className="text-white text-sm font-semibold" style={{ fontFamily: "Outfit" }}>{t.name}</p>
                  <p className="text-gray-500 text-xs">{t.title}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
